import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { FormControlLabel, IconButton, Radio, Typography } from '@mui/material';
import React from 'react';
import { SubscriptionTierBadge, UpgradeNow } from 'src/components/SubscriptionTier';
import { MAIL_CHOICE } from './setupEditor';

// The AP Push switch's info icon: 20px inside the theme's small icon button.
const INFO_BUTTON = {
  padding: '2px',
  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px'
  }
};

// property-service answers errors in PascalCase: { Error: { ErrorCode, GeneralErrorMessage } }.
export const messageOf = (err, fallback) => {
  var _err$response;
  const message = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 || (_err$response = _err$response.Error) === null || _err$response === void 0 ? void 0 : _err$response.GeneralErrorMessage;
  return typeof message === 'string' && message.length <= 300 ? message : fallback;
};
export const sameId = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();
export const Tip = _ref => {
  let label = _ref.label,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: text,
    placement: "top",
    describeChild: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": "About ".concat(label),
    sx: INFO_BUTTON
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "info"
  })));
};

/**
 * A plan the company isn't on yet, with what it includes behind its badge's info icon, and Upgrade now (LB-6187).
 * `where` names the screen in the upgrade request.
 */
export const Needs = _ref2 => {
  let tier = _ref2.tier,
    where = _ref2.where,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, "Needs ", /*#__PURE__*/React.createElement(SubscriptionTierBadge, {
    tier: tier
  }), /*#__PURE__*/React.createElement(UpgradeNow, {
    tier: tier,
    where: where
  }));
};

/**
 * One way bills reach Livable, as a card that's its radio's label: the setup editor's and New setup's. A card the plan
 * doesn't include carries its lock under the label, not in it: Upgrade now inside a radio's label would pick the radio
 * and be read as part of its name.
 */
export const SourceCard = _ref3 => {
  let choice = _ref3.choice,
    selected = _ref3.selected,
    locked = _ref3.locked,
    needs = _ref3.needs,
    where = _ref3.where,
    classes = _ref3.classes;
  const cardClass = "".concat(classes.card, " ").concat(selected ? classes.cardSelected : '');
  const label = /*#__PURE__*/React.createElement(FormControlLabel, {
    value: choice.value,
    disabled: locked,
    className: needs ? classes.cardLabel : cardClass,
    control: /*#__PURE__*/React.createElement(Radio, {
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement("span", {
      className: classes.cardText
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      component: "span",
      className: classes.cardTitle
    }, choice.title), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      component: "span",
      color: "light"
    }, choice.sub))
  });
  if (!needs) return label;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(cardClass, " ").concat(classes.cardBox)
  }, label, /*#__PURE__*/React.createElement(Needs, {
    tier: needs,
    where: where,
    className: "".concat(classes.needs, " ").concat(classes.cardNeeds)
  }));
};

/** Bills by mail: shown in the source cards, never chosen, since it's coming soon. */
export const MailCard = _ref4 => {
  let classes = _ref4.classes;
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "__mail",
    disabled: true,
    className: classes.card,
    control: /*#__PURE__*/React.createElement(Radio, {
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement("span", {
      className: classes.cardText
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      component: "span",
      className: classes.cardTitle
    }, MAIL_CHOICE.title, " ", /*#__PURE__*/React.createElement("span", {
      className: classes.soon
    }, "Coming soon")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      component: "span",
      color: "light"
    }, MAIL_CHOICE.sub))
  });
};